import styled from "styled-components";
export const GridWrapper = styled.div.withConfig({
    displayName: "styled__GridWrapper",
    componentId: "sc-b5a9d508-0"
})`
	display: grid;
	grid-gap: 16px;
	grid-template-columns: repeat(2, 1fr);
	padding: 0;
	grid-auto-rows: 1fr;

	${({ theme  })=>theme.media.up('lg')} {
		grid-template-columns: repeat(${({ breakpoints  })=>breakpoints['lg']}, 1fr);
	}

	${({ theme  })=>theme.media.up('xl')} {
		grid-template-columns: repeat(${({ breakpoints  })=>breakpoints['xl']}, 1fr);
	}

	${({ theme  })=>theme.media.up('xxl')} {
		grid-template-columns: repeat(${({ breakpoints  })=>breakpoints['xxl']}, 1fr);
	}
`;
export const CardSkeletonWrapper = styled.div.withConfig({
    displayName: "styled__CardSkeletonWrapper",
    componentId: "sc-b5a9d508-1"
})`
	padding: 0px 2px;
`;

//# sourceMappingURL=styled.js.map